{
  "familyId": "MET-SCHAAL-OPP",
  "questions": [
    {
      "id": "MET-SCHAAL-OPP-001",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de echte oppervlakte bij schaal 1:100. Hij zegt: \"1 cm² op de kaart = 100 cm² in het echt.\" Wat is zijn fout?",
      "options": ["Hij vergeet de schaalfactor te kwadrateren: het moet 100² = 10.000 cm² zijn", "Hij moet door 100 delen in plaats van vermenigvuldigen", "Hij moet met 1000 vermenigvuldigen", "Er zit geen fout in zijn berekening"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schaal bij oppervlakte",
            "content": "Bij oppervlakte moet je de schaal kwadrateren! Schaal 1:100 betekent: 1 cm op de kaart = 100 cm in het echt. Voor oppervlakte: 1 cm² = 100² cm² = 10.000 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "scale_area_error_analysis",
      "variantIndex": 1,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De leerling vergeet te kwadrateren. Bij lengte is het ×100, maar bij oppervlakte moet je de schaalfactor kwadrateren: 100² = 10.000. Dit komt doordat oppervlakte twee dimensies heeft (lengte × breedte), dus je vermenigvuldigt twee keer met 100. De juiste berekening: 1 cm² × 10.000 = 10.000 cm² in het echt.",
        "solutionSteps": [
          "Analyseer de bewering: de leerling zegt 1 cm² = 100 cm²",
          "Herken de fout: bij oppervlakte moet je de schaalfactor kwadrateren",
          "Bereken correct: 100² = 10.000, dus 1 cm² = 10.000 cm²",
          "Verklaring: oppervlakte = lengte × breedte, dus 100 × 100 = 10.000"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! Bij oppervlakte kwadrateer je de schaalfactor: 100² = 10.000. De leerling vergeet dit en gebruikt alleen ×100.",
          "1": "Je dacht waarschijnlijk dat je moet delen. Maar van kaart naar echt ga je naar grotere maten, dus je vermenigvuldigt. Bij oppervlakte: ×100² = ×10.000.",
          "2": "Je dacht waarschijnlijk dat het ×1000 is. Maar bij schaal 1:100 kwadrateer je 100: 100² = 10.000, niet 1000. Onthoud: oppervlakte = schaalfactor².",
          "3": "Er zit wél een fout in: 1 cm² ≠ 100 cm². Bij oppervlakte kwadrateer je: 1 cm² = 100² cm² = 10.000 cm². De leerling verwart lengte-omrekening met oppervlakte-omrekening."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-002",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de echte oppervlakte van een kamer (4 cm² op plattegrond, schaal 1:50). Hij schrijft: \"4 × 50 = 200 cm².\" Zijn klasgenoot zegt: \"Je mist een stap.\" Welke stap mist de leerling?",
      "options": ["Hij moet de schaalfactor kwadrateren: 4 × 50² = 4 × 2.500 = 10.000 cm²", "Hij moet door 50 delen in plaats van vermenigvuldigen", "Hij moet eerst de wortel van 4 nemen", "Hij moet met 500 vermenigvuldigen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schaal bij oppervlakte",
            "content": "Schaal 1:50 betekent: 1 cm op de plattegrond = 50 cm in het echt. Voor oppervlakte: 4 cm² × 50² = 4 × 2.500 = 10.000 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "scale_area_error_context",
      "variantIndex": 2,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "De leerling vermenigvuldigt met 50, maar bij oppervlakte moet je de schaalfactor kwadrateren. De juiste berekening: 4 × 50² = 4 × 2.500 = 10.000 cm². Dit komt doordat oppervlakte twee dimensies heeft: de lengte wordt ×50 én de breedte wordt ×50, dus samen ×2.500.",
        "solutionSteps": [
          "Analyseer de berekening: de leerling doet 4 × 50 = 200",
          "Herken de fout: bij oppervlakte kwadrateer je de schaalfactor",
          "Bereken correct: 4 × 50² = 4 × 2.500 = 10.000 cm²",
          "Verklaring: oppervlakte heeft twee dimensies, dus 50 × 50 = 2.500"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! De leerling vergeet te kwadrateren. Bij oppervlakte: 4 × 50² = 4 × 2.500 = 10.000 cm², niet 4 × 50 = 200 cm².",
          "1": "Je dacht waarschijnlijk dat je moet delen. Maar van plattegrond naar echt ga je naar grotere maten, dus je vermenigvuldigt. Bij oppervlakte: ×50² = ×2.500.",
          "2": "Je dacht waarschijnlijk dat je de wortel van de oppervlakte moet nemen. Maar je kwadratéért de schaalfactor, niet de oppervlakte. Onthoud: oppervlakte × schaalfactor².",
          "3": "Je dacht waarschijnlijk dat het ×500 is. Maar bij schaal 1:50 kwadrateer je 50: 50² = 2.500, niet 500. Onthoud: oppervlakte = schaalfactor²."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-003",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de echte oppervlakte van een tuin (3 cm × 5 cm op plattegrond, schaal 1:200). Hij schrijft: \"3 × 5 = 15 cm². Dan 15 × 200 = 3.000 cm² = 0,3 m².\" Wat doet de leerling fout?",
      "options": ["Hij vermenigvuldigt met 200 in plaats van met 200² = 40.000", "Hij rekent cm² verkeerd om naar m²", "Hij moet de lengtes eerst apart omrekenen", "Er zitten twee fouten in zijn berekening"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": { "width": 5, "height": 3, "showGrid": true, "unit": "cm", "label": "Plattegrond 1:200" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schaal bij oppervlakte — stap voor stap",
            "content": "Bij oppervlakte kwadrateer je de schaalfactor. Methode 1: 15 cm² × 200² = 15 × 40.000 = 600.000 cm² = 60 m². Methode 2: 3 × 200 = 600 cm = 6 m, 5 × 200 = 1.000 cm = 10 m, 6 × 10 = 60 m².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "scale_area_error_direct",
      "variantIndex": 3,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De leerling maakt de klassieke fout: hij vermenigvuldigt de oppervlakte met de schaalfactor (×200) in plaats van met het kwadraat van de schaalfactor (×200² = ×40.000). Dit komt doordat oppervlakte twee dimensies heeft: zowel de lengte als de breedte worden ×200. Dus de oppervlakte wordt ×200 × ×200 = ×40.000. De juiste berekening: 15 cm² × 40.000 = 600.000 cm² = 60 m². Je kunt controleren via de lengtes: 6 m × 10 m = 60 m². De leerling krijgt 0,3 m², het juiste antwoord is 60 m² — een factor 200 verschil.",
        "solutionSteps": [
          "Analyseer de berekening: de leerling doet 15 × 200 = 3.000 cm²",
          "Identificeer de fout: bij oppervlakte moet je ×200² gebruiken, niet ×200",
          "Verklaar waarom: oppervlakte = lengte × breedte, dus beide dimensies ×200 → ×40.000",
          "Bereken correct: 15 × 40.000 = 600.000 cm² = 60 m²",
          "Controleer via lengtes: 3 cm × 200 = 6 m, 5 cm × 200 = 10 m, 6 × 10 = 60 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! De leerling vergeet te kwadrateren. Bij oppervlakte: ×200² = ×40.000, niet ×200. Het juiste antwoord is 15 × 40.000 = 600.000 cm² = 60 m².",
          "1": "Je dacht waarschijnlijk dat de fout in de omrekening naar m² zit. De leerling rekent 3.000 cm² = 0,3 m² — dat klopt (3.000 ÷ 10.000 = 0,3). De echte fout zit eerder: hij vermenigvuldigt met 200 i.p.v. 200².",
          "2": "De lengtes apart omrekenen is een geldige methode (6 m × 10 m = 60 m²), maar het is niet de fout. De fout is dat de leerling ×200 gebruikt i.p.v. ×200². Beide methodes geven 60 m² als je ze correct toepast.",
          "3": "Er zit maar één kernfout in: ×200 i.p.v. ×200². De omrekening cm² → m² (÷10.000) past de leerling correct toe op zijn (foutieve) tussenresultaat. De oplossing is: kwadrateer de schaalfactor bij oppervlakte."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-004",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een woonkamer van 24 m² op een plattegrond met schaal 1:50. Een leerling berekent: \"24 ÷ 50 = 0,48 cm².\" Zijn klasgenoot zegt: \"Je vergeet twee stappen.\" Welke twee stappen mist de leerling?",
      "options": ["Hij moet eerst omrekenen naar cm² (24 m² = 240.000 cm²) én delen door 50² in plaats van 50", "Hij moet vermenigvuldigen in plaats van delen, en omrekenen naar cm²", "Hij moet door 50² delen en dan met 100 vermenigvuldigen", "Hij hoeft alleen door 50² te delen, de eenheden kloppen al"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van echt naar plattegrond",
            "content": "Stap 1: Zelfde eenheid — 24 m² = 240.000 cm². Stap 2: Deel door schaalfactor² — 240.000 ÷ 50² = 240.000 ÷ 2.500 = 96 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "scale_area_reverse_error",
      "variantIndex": 4,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.65,
      "feedback": {
        "explanationText": "De leerling maakt twee fouten tegelijk. Fout 1: hij deelt door 50 in plaats van door 50² = 2.500 (bij oppervlakte kwadrateer je de schaalfactor). Fout 2: hij rekent niet om naar dezelfde eenheid — 24 m² ≠ 24 cm². De juiste aanpak: eerst 24 m² = 240.000 cm², dan 240.000 ÷ 2.500 = 96 cm². De leerling krijgt 0,48 cm², het juiste antwoord is 96 cm² — een enorm verschil door twee gemiste stappen.",
        "solutionSteps": [
          "Analyseer de berekening: de leerling doet 24 ÷ 50 = 0,48",
          "Identificeer fout 1: de leerling deelt door 50 i.p.v. 50² = 2.500",
          "Identificeer fout 2: de leerling behandelt 24 m² alsof het 24 cm² is",
          "Corrigeer stap 1: 24 m² = 24 × 10.000 = 240.000 cm²",
          "Corrigeer stap 2: 240.000 ÷ 2.500 = 96 cm²",
          "Controleer: 96 × 2.500 = 240.000 cm² = 24 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! De leerling mist twee stappen: (1) omrekenen naar cm² (24 m² = 240.000 cm²) en (2) delen door 50² = 2.500 i.p.v. 50. Juist antwoord: 240.000 ÷ 2.500 = 96 cm².",
          "1": "Je dacht waarschijnlijk dat de leerling moet vermenigvuldigen. Maar van echt naar plattegrond ga je naar kleinere maten, dus je deelt. De twee fouten zijn: verkeerde eenheid (m² vs. cm²) en niet kwadrateren (÷50 i.p.v. ÷2.500).",
          "2": "Je dacht waarschijnlijk dat je na het delen nog met 100 moet vermenigvuldigen. Maar als je eerst correct omrekent naar cm² (240.000) en dan deelt door 50² (2.500), krijg je direct het antwoord in cm²: 96 cm².",
          "3": "Alleen door 50² delen is niet genoeg — de leerling moet ook de eenheden omrekenen. 24 m² ÷ 2.500 = 0,0096 m², maar de plattegrond is in cm². Eerst: 24 m² = 240.000 cm², dan: 240.000 ÷ 2.500 = 96 cm²."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-005",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Twee leerlingen berekenen de echte oppervlakte van een park (2 cm × 4 cm op plattegrond, schaal 1:300). Leerling A: \"2 × 300 = 600 cm = 6 m, 4 × 300 = 1.200 cm = 12 m, 6 × 12 = 72 m².\" Leerling B: \"2 × 4 = 8 cm², 8 × 300² = 720.000 cm² = 72 m².\" Beoordeel beide methodes.",
      "options": ["Beide methodes zijn correct en geven hetzelfde antwoord (72 m²)", "Alleen methode A is correct, B maakt een rekenfout", "Alleen methode B is correct, A vergeet te kwadrateren", "Beide methodes zijn fout, het antwoord is 2.400 m²"],
      "correctAnswer": 0,
      "data": null,
      "stimulusAids": [
        {
          "type": "geo",
          "data": { "width": 4, "height": 2, "showGrid": true, "unit": "cm", "label": "Plattegrond 1:300" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee methodes voor schaal bij oppervlakte",
            "content": "Methode A: reken lengtes apart om, dan vermenigvuldigen. Methode B: reken kaartoppervlakte om met schaalfactor². Beide geven hetzelfde antwoord als je ze correct toepast.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "scale_area_compare_methods",
      "variantIndex": 5,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "Beide methodes zijn wiskundig correct en geven hetzelfde antwoord. Methode A (lengtes apart omrekenen): 6 m × 12 m = 72 m². Methode B (oppervlakte × schaalfactor²): 8 × 90.000 = 720.000 cm² = 72 m². Dit is geen toeval — het is wiskundig equivalent: (2×300) × (4×300) = 2×4 × 300² = 8 × 90.000. Het verschil is de aanpak, niet het resultaat. Methode A is vaak makkelijker te begrijpen, methode B is sneller bij complexe vormen.",
        "solutionSteps": [
          "Controleer methode A: 2 × 300 = 600 cm = 6 m, 4 × 300 = 1.200 cm = 12 m, 6 × 12 = 72 m² ✓",
          "Controleer methode B: 2 × 4 = 8 cm², 300² = 90.000, 8 × 90.000 = 720.000 cm² = 72 m² ✓",
          "Vergelijk: beide geven 72 m² — wiskundig equivalent",
          "Verklaar waarom: (a×300) × (b×300) = a×b × 300² — de volgorde van vermenigvuldigen maakt niet uit",
          "Beoordeel: methode A is inzichtelijker, methode B is efficiënter"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! Beide methodes zijn correct. A rekent lengtes apart om (6 × 12 = 72 m²), B gebruikt schaalfactor² (8 × 90.000 = 720.000 cm² = 72 m²). Wiskundig equivalent.",
          "1": "Je dacht waarschijnlijk dat methode B een fout bevat. Maar 8 × 300² = 8 × 90.000 = 720.000 cm² = 72 m² is correct. Methode B kwadratéért de schaalfactor, wat wiskundig hetzelfde is als beide lengtes apart omrekenen.",
          "2": "Je dacht waarschijnlijk dat methode A vergeet te kwadrateren. Maar methode A hoeft niet te kwadrateren — hij rekent elke lengte apart om (×300) en vermenigvuldigt daarna. Dat is wiskundig hetzelfde als ×300².",
          "3": "Beide methodes geven 72 m², niet 2.400 m². 2.400 zou je krijgen als je 8 × 300 doet (zonder te kwadrateren) — dat is de veelgemaakte fout die beide leerlingen juist vermijden."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-006",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent bij schaal 1:500: \"2 cm² op de plattegrond = 2 × 500 = 1.000 cm². Dat is 1.000 ÷ 10.000 = 0,1 m².\" Corrigeer de berekening. Wat is de echte oppervlakte?",
      "options": ["50 m², want je moet met 500² = 250.000 vermenigvuldigen", "0,1 m², de berekening klopt", "10 m², want je moet met 5.000 vermenigvuldigen", "100 m², want je moet met 500.000 vermenigvuldigen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schaal 1:500 bij oppervlakte",
            "content": "Bij oppervlakte kwadrateer je de schaalfactor: 500² = 250.000. Echte oppervlakte = 2 × 250.000 = 500.000 cm² = 50 m².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "scale_area_large_factor_error",
      "variantIndex": 6,
      "citoDifficulty": 0.53,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "De leerling maakt de klassieke fout: hij vermenigvuldigt met 500 in plaats van met 500² = 250.000. Bij oppervlakte heeft elke dimensie de schaalfactor, dus je vermenigvuldigt twee keer: 500 × 500 = 250.000. De juiste berekening: 2 cm² × 250.000 = 500.000 cm². Omrekenen: 500.000 ÷ 10.000 = 50 m². De leerling krijgt 0,1 m², het juiste antwoord is 50 m² — een factor 500 verschil, precies de ontbrekende schaalfactor.",
        "solutionSteps": [
          "Analyseer de berekening: de leerling doet 2 × 500 = 1.000 cm²",
          "Identificeer de fout: bij oppervlakte kwadrateer je de schaalfactor → 500² = 250.000",
          "Verklaar waarom: oppervlakte = lengte × breedte, dus ×500 × ×500 = ×250.000",
          "Bereken correct: 2 × 250.000 = 500.000 cm² = 50 m²",
          "Controleer: het verschil (0,1 m² vs. 50 m²) is precies factor 500 — de ontbrekende schaalfactor ✓"
        ],
        "distractorExplanations": {
          "0": "Goed gecorrigeerd! De leerling vergeet te kwadrateren: 2 × 500² = 2 × 250.000 = 500.000 cm² = 50 m². Het verschil met zijn antwoord (0,1 m²) is precies factor 500.",
          "1": "De berekening klopt niet. De leerling vermenigvuldigt met 500, maar bij oppervlakte moet je met 500² = 250.000 vermenigvuldigen. Het juiste antwoord is 50 m², niet 0,1 m².",
          "2": "Je dacht waarschijnlijk dat het ×5.000 is. Maar bij schaal 1:500 kwadrateer je 500: 500² = 250.000, niet 5.000. Onthoud: oppervlakte = schaalfactor², dus 500 × 500 = 250.000.",
          "3": "Je dacht waarschijnlijk dat het ×500.000 is. Maar 500² = 250.000, niet 500.000. 2 × 250.000 = 500.000 cm² = 50 m², niet 100 m². Onthoud: kwadrateren = ×zichzelf, niet ×1.000."
        }
      }
    }
  ]
}